import { Star } from "lucide-react";
import maleAvatar1 from "@/assets/avatars/male-avatar-1.png";
import maleAvatar2 from "@/assets/avatars/male-avatar-2.png";
import femaleAvatar1 from "@/assets/avatars/female-avatar-1.png";
import femaleAvatar2 from "@/assets/avatars/female-avatar-2.png";

const testimonials = [
  {
    name: "Rahim Ahmed",
    role: "CEO, TechBD Solutions",
    content: "Web Host Buy BD has been instrumental in our online success. The BDIX connectivity is blazing fast and their support team is incredibly responsive.",
    rating: 5,
    avatar: maleAvatar1,
  },
  {
    name: "Fatima Khan",
    role: "Founder, E-Shop BD",
    content: "Switched to Web Host Buy BD 2 years ago and never looked back. Our e-commerce site loads instantly and we've had zero downtime.",
    rating: 5,
    avatar: femaleAvatar1,
  },
  {
    name: "Kamal Hossain",
    role: "Developer, Freelancer",
    content: "Best hosting provider in Bangladesh! The NVMe SSDs make a huge difference. My clients' websites are faster than ever.",
    rating: 5,
    avatar: maleAvatar2,
  },
  {
    name: "Nasreen Begum",
    role: "Blogger, TravelBD",
    content: "Affordable prices, excellent features, and top-notch support. Highly recommend for anyone looking for quality hosting in Bangladesh.",
    rating: 5,
    avatar: femaleAvatar2,
  },
];

const TestimonialsSection = () => {
  return (
    <section className="py-20 bg-background">
      <div className="container-custom">
        <div className="text-center mb-16 animate-fade-in-up">
          <span className="inline-block px-4 py-1.5 rounded-full bg-blue-50 text-primary text-sm font-medium mb-4">
            Testimonials
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            What Our Clients Say
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Join thousands of satisfied customers who trust us with their online presence.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.name}
              className="p-6 rounded-2xl bg-card border border-border card-hover animate-fade-in-up"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="flex justify-center md:justify-start gap-1 mb-4">
                {Array.from({ length: testimonial.rating }).map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-orange-500 text-orange-500" />
                ))}
              </div>
              <p className="text-foreground mb-6 text-sm leading-relaxed text-center md:text-left">
                "{testimonial.content}"
              </p>
              <div className="flex flex-col md:flex-row items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img 
                    src={testimonial.avatar} 
                    alt={`${testimonial.name} testimonial`}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="text-center md:text-left">
                  <div className="font-medium text-foreground text-sm">
                    {testimonial.name}
                  </div>
                  <div className="text-muted-foreground text-xs">
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
